import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import Input from 'components/lib/Input';
import { CommunityType } from 'types/communities';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .main {
    font-size: 14px;
    font-family: var(--font-bold);
    color: var(--text-primary);
  }
  .description {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: var(--gray-dark);
  }
`;

const ShopRequestPropagateModalContentListEmpty = () => (
  <Container>
    <span className={'main'}>There are no communities to propagate to right now.</span>
    <span className={'description'}>
      <span>This list may be populated later if the community is added as</span>
      <span>competitor to others during the mystery shop.</span>
    </span>
  </Container>
);

export default ShopRequestPropagateModalContentListEmpty;
